var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailCm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.25H3C1.48 0.25 0.25 1.48 0.25 3V11C0.25 12.52 1.48 13.75 3 13.75H17C18.52 13.75 19.75 12.52 19.75 11V3C19.75 1.48 18.52 0.25 17 0.25ZM17 1.75C17 1.75 17.08 1.77 17.12 1.77L10.82 7.28C10.35 7.69 9.64 7.69 9.17 7.28L2.88 1.77C2.88 1.77 2.96 1.75 3 1.75H17ZM18.25 11C18.25 11.69 17.69 12.25 17 12.25H3C2.31 12.25 1.75 11.69 1.75 11V3C1.75 2.93 1.78 2.88 1.79 2.81L8.19 8.41C8.71 8.86 9.35 9.09 10 9.09C10.65 9.09 11.29 8.86 11.81 8.41L18.21 2.81C18.22 2.87 18.25 2.93 18.25 3V11Z",
    fill: "#2A364E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCm);
export default __webpack_public_path__ + "static/media/emailCM.9dc4b8ebb85f2caa183e311c0a3e8c50.svg";
export { ForwardRef as ReactComponent };